export default "__VITE_ASSET__B89z2aj1__"